<template>
  <v-container fluid py-0 style="background-color: #E4E7EA;">
    <v-container class="pb-15 pt-10">
      <v-row>
        <v-col cols="12">
          <div class="font-weight-medium secondary--text section-title">
            Shema osoba
          </div>
        </v-col>
        <v-col cols="12">
          <div class="primary--text">
            Na ovoj web stranici možete vidjeti
            <span class="font-weight-bold">shemu osoba</span>.
          </div>
        </v-col>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="persons"
            disable-sort
            class="primary--text table-scheme"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:[`item.opis`]="{ item }">
              <v-menu
                left
                :key="item.naziv"
                max-width="500"
                min-width="250"
                offset-x
              >
                <template v-slot:activator="{ on }">
                  <v-btn class="accent elevation-0 px-6 text-none" v-on="on"
                    >Više</v-btn
                  >
                </template>

                <v-card elevation="0">
                  <v-list two-line class="description secondary--text">
                    <v-list-item>
                      <v-list-item-icon class="pr-4 mb-4">
                        <v-img
                          width="70px"
                          src="../../assets/sumit-logo.svg"
                          alt="SUM"
                        ></v-img>
                      </v-list-item-icon>

                      <v-list-item-content class="align-self-start">
                        <v-list-item-title
                          class="secondary--text font-weight-medium"
                          >{{ item.naziv }}</v-list-item-title
                        >
                        <v-list-item-subtitle class="secondary--text">
                          <span class="font-weight-bold">LDAP naziv: </span>
                          <span class="d-block d-sm-inline">{{
                            item.LDAP_naziv
                          }}</span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>

                  <v-divider></v-divider>

                  <v-card-text>
                    <strong class="secondary--text">Detaljan opis:</strong>
                    <br />
                    <div class="primary--text mt-2">{{ item.opis }}</div>
                  </v-card-text>
                </v-card>
              </v-menu>
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <div v-if="item.status === 'obvezan'" class="red--text">
                {{ item.status }}
              </div>
              <div v-else class="green--text">
                {{ item.status }}
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  components: {},
  data: () => ({
    headers: [
      { text: "Naziv atributa", value: "naziv" },
      { text: "LDAP naziv", value: "LDAP_naziv" },
      { text: "Status", value: "status" },
      { text: "Frekvencija", value: "frekvencija" },
      { text: "Detalji", value: "opis" }
    ],
    persons: [
      {
        naziv: "Korisnička oznaka",
        LDAP_naziv: "sumEduPersonUniqueID",
        status: "obvezan",
        frekvencija: "1",
        opis:
          "Vrijednost atributa je jedinstvena korisnička oznaka osobe u sustavu AAI@SUM.ba. Koristi se pri interinstitucionalnoj autentikaciji. Sintaksa: <lokalni_id>@<identifikator_imenika>."
      },
      {
        naziv: "Identifikator korisnika u ustanovi",
        LDAP_naziv: "uid",
        status: "obvezan",
        frekvencija: "1",
        opis:
          "Identifikator korisnika (login-name; userid) kojom se identificira osoba na matičnoj ustanovi. Mora imati istu vrijednost kao lokalni_id u atributu sumEduPersonUniqueID (korisnička oznaka)."
      },
      {
        naziv: "Zaporka",
        LDAP_naziv: "userPassword",
        status: "obvezan",
        frekvencija: "1",
        opis:
          "Korisnička zaporka, koristi se pri autentikaciji. Preporuča se čuvati je u imeniku kriptiranu."
      },
      {
        naziv: "Ime i prezime",
        LDAP_naziv: "cn",
        status: "obvezan",
        frekvencija: "n",
        opis: "Puno ime i prezime osobe."
      },
      {
        naziv: "Prezime",
        LDAP_naziv: "sn",
        status: "obvezan",
        frekvencija: "n",
        opis: "Prezime osobe."
      },
      {
        naziv: "Ime",
        LDAP_naziv: "givenName",
        status: "obvezan",
        frekvencija: "n",
        opis: "Ime osobe."
      },
      {
        naziv: "Elektronička adresa",
        LDAP_naziv: "mail",
        status: "obvezan",
        frekvencija: "n",
        opis:
          "Elektronička adresa osobe. Nužno je da jedna od vrijednosti ovoga atributa bude i službena elektronička adresa osobe (ona koju matična ustanova koristi za korespodenciju s osobom)."
      },
      {
        naziv: "Telefonski broj",
        LDAP_naziv: "telephoneNumber",
        status: "opcionalan",
        frekvencija: "n",
        opis: "Telefonski broj osobe u ustanovi."
      },
      {
        naziv: "Lokalni telefonski broj",
        LDAP_naziv: "sumEduPersonExtensionNumber",
        status: "opcionalan",
        frekvencija: "n",
        opis: "Lokalni telefonski broj osobe u ustanovi."
      },
      {
        naziv: "Broj mobilnog telefona",
        LDAP_naziv: "mobile",
        status: "opcionalan",
        frekvencija: "n",
        opis: "Broj mobilnog telefona osobe."
      },
      {
        naziv: "Fax broj",
        LDAP_naziv: "facsimileTelephoneNumber",
        status: "opcionalan",
        frekvencija: "n",
        opis: "Fax broj u ustanovi."
      },
      {
        naziv: "Brojčani identifikator osobe",
        LDAP_naziv: "sumEduPersonUniqueNumber",
        status: "obvezan",
        frekvencija: "n",
        opis:
          "Vrijednost atributa je brojčani identifikator osobe. Koristi se za dodatnu provjeru identiteta kod autorizacije. Sintaksa: tip_identifikatora:<vrijednost>. tip_identifikatora ima kontrolirani skup vrijednosti i one mogu biti: OIB, JMBG, JMBAG, MBZ, PASSPORT_NO, LOCAL_NO."
      },
      {
        naziv: "Spol",
        LDAP_naziv: "sumEduPersonGender",
        status: "opcionalan",
        frekvencija: "1",
        opis: "Spol osobe."
      },
      {
        naziv: "Datum rođenja",
        LDAP_naziv: "sumEduPersonDateOfBirth",
        status: "opcionalan",
        frekvencija: "1",
        opis: "Datum rođenja osobe zapisan po RFC 3339 standardu (ggggmmdd)."
      },
      {
        naziv: "Slika",
        LDAP_naziv: "jpegPhoto",
        status: "opcionalan",
        frekvencija: "n",
        opis: "Slika osobe u jpeg formatu."
      },
      {
        naziv: "URI adresa",
        LDAP_naziv: "labeledURI",
        status: "opcionalan",
        frekvencija: "n",
        opis: "URI (URL) adresa vezana uz osobu."
      },
      {
        naziv: "Stručni status",
        LDAP_naziv: "sumEduPersonProfessionalStatus",
        status: "opcionalan",
        frekvencija: "1",
        opis:
          "Najviši stupanj stručne spreme ili akademski stupanj koji osoba posjeduje."
      },
      {
        naziv: "Zvanje",
        LDAP_naziv: "sumEduPersonAcademicStatus",
        status: "opcionalan",
        frekvencija: "1",
        opis:
          "Zvanje koje je osoba stekla u sustavu znanosti i visokog školstva."
      },
      {
        naziv: "Područje znanosti",
        LDAP_naziv: "sumEduPersonScienceArea",
        status: "opcionalan",
        frekvencija: "n",
        opis: "Područje znanosti kojim se osoba bavi."
      },
      {
        naziv: "Povezanost s ustanovom",
        LDAP_naziv: "sumEduPersonAffiliation",
        status: "obvezan",
        frekvencija: "n",
        opis:
          "Određuje veze između osobe i matične ustanove (primjerice student, djelatnik, ...). Ako je osoba vezana uz ustanovu na više načina, potrebno je upisati sve veze."
      },
      {
        naziv: "Temeljna povezanost s ustanovom",
        LDAP_naziv: "sumEduPersonPrimaryAffiliation",
        status: "obvezan",
        frekvencija: "1",
        opis:
          "Temeljna (primarna) veza između osobe i matične ustanove. Mora biti jedna od vrijednosti upisana u atributu povezanost s ustanovom"
      },
      {
        naziv: "Vrsta studenta",
        LDAP_naziv: "sumEduPersonStudentCategory",
        status: "opcionalan",
        frekvencija: "1",
        opis:
          "Detaljnija informacija o osobi koja je uz ustanovu vezana kao student ili učenik."
      },
      {
        naziv: "Datum isteka temeljne povezanosti",
        LDAP_naziv: "SumEduPerosnExpireDate",
        status: "obvezan",
        frekvencija: "1",
        opis:
          "Datum do kojeg vrijedi odnos s ustanovom definiran u temeljnoj povezanosti."
      },
      {
        naziv: "Oznaka valjanosti korisničkog računa",
        LDAP_naziv: "sumEduAllowAccess",
        status: "obvezan",
        frekvencija: "1",
        opis: "Postavlja zabranu pristupa za određenog korisnika."
      },
      {
        naziv: "Položaj u ustanovi",
        LDAP_naziv: "sumEduPersonTitle",
        status: "opcionalan",
        frekvencija: "1",
        opis:
          "Položaj osobe u organizacijskoj shemi ustanove (primjerice voditelj odjela ili ravnatelj)."
      },
      {
        naziv: "Uloga u ustanovi",
        LDAP_naziv: "sumEduPersonRole",
        status: "opcionalan",
        frekvencija: "1",
        opis:
          "Uloga/funkcija koju osoba ima u ustanovi ili obnaša u ime ustanove."
      },
      {
        naziv: "Vrsta posla u ustanovi",
        LDAP_naziv: "sumEduPersonStaffCategory",
        status: "opcionalan",
        frekvencija: "n",
        opis:
          "Vrsta posla koju osoba obavlja u ustanovi (npr. nastavnik, istraživač, administrativno osoblje, ...)."
      },
      {
        naziv: "Pripadnost grupi",
        LDAP_naziv: "sumEduPersonGroupMember",
        status: "opcionalan",
        frekvencija: "n",
        opis:
          "Grupa kojoj korisnik pripada. Određuje se za potrebe projekata ili virtualnih organizacija."
      },
      {
        naziv: "Naziv matične ustanove",
        LDAP_naziv: "o",
        status: "obvezan",
        frekvencija: "n",
        opis:
          "Puni službeni naziv matične ustanove koja je dodijelila elektronički identitet."
      },
      {
        naziv: "Oznaka matične ustanove",
        LDAP_naziv: "sumEduPersonHomeOrg",
        status: "obvezan",
        frekvencija: "1",
        opis:
          "Tzv. realm. Jednoznačno idetificira ustanovu u sutavu AAI, odgovara DNS (Internet) domeni matične ustanove."
      },
      {
        naziv: "Organizacijska jedinica",
        LDAP_naziv: "ou",
        status: "opcionalan",
        frekvencija: "n",
        opis:
          "Naziv organizacijske jedinice kojoj pripada osoba (sukladno unutarnjem ustroju matične ustanove)."
      },
      {
        naziv: "Broj sobe",
        LDAP_naziv: "roomNumber",
        status: "opcionalan",
        frekvencija: "n",
        opis: "Broj sobe u ustanovi."
      },
      {
        naziv: "Poštanska adresa",
        LDAP_naziv: "postalAdress",
        status: "obvezan",
        frekvencija: "1",
        opis:
          "Službena adresa (u ustanovi) koju je potrebno napisati na poštansku pošiljku poslanu osobi (puni oblik)."
      },
      {
        naziv: "Mjesto (lokalitet)",
        LDAP_naziv: "l",
        status: "obvezan",
        frekvencija: "1",
        opis: "Mjesto iz službene adrese."
      },
      {
        naziv: "Poštanski broj",
        LDAP_naziv: "postalCode",
        status: "opcionalan",
        frekvencija: "1",
        opis:
          "Poštanski broj iz službene adrese zapisan prema službenoj poštanskoj normi."
      },
      {
        naziv: "Ulica i kućni broj",
        LDAP_naziv: "street",
        status: "opcionalan",
        frekvencija: "1",
        opis: "Ulica i kućni broj iz službene adrese."
      },
      {
        naziv: "Kućna poštanska adresa",
        LDAP_naziv: "homePostalAdress",
        status: "opcionalan",
        frekvencija: "n",
        opis:
          "Puna kućna adresa (koju je potrebno napisati na poštansku pošiljku poslanu osobi)."
      },
      {
        naziv: "Kućni telefonski broj",
        LDAP_naziv: "homeTelephoneNumber",
        status: "opcionalan",
        frekvencija: "n",
        opis: "Telefonski broj osobe kod kuće."
      },
      {
        naziv: "Oznaka privatnosti",
        LDAP_naziv: "sumEduPersonPrivacy",
        status: "opcionalan",
        frekvencija: "n",
        opis:
          "Omogućuje označavanje atributa čiji sadržaj neće biti dostupan izvan matične ustanove. Pruža mogućnost da se pojedini podaci o osobi zaštite od pristupa osim u lokalne svrhe."
      },
      {
        naziv: "Trajna korisnička oznaka",
        LDAP_naziv: "sumEduPersonPersistentID",
        status: "obvezan",
        frekvencija: "1",
        opis:
          "Vrijednost atributa je jedinstvena i trajna korisnička oznaka osobe u sustavu AAI. Izvodi se, automatizmom uz primjenu hashing postupka, od vrijednosti atributa sumEduPersonUniqueID te datuma i vremena kreiranja elektroničkog identiteta. Vrijednost ovoga atributa ne može se naknadno mijenjati."
      },
      {
        naziv: "Ime oca",
        LDAP_naziv: "sumEduPersonFatherName",
        status: "opcionalan",
        frekvencija: "1",
        opis: "Ime oca."
      },
      {
        naziv: "Ime majke",
        LDAP_naziv: "sumEduPersonMotherName",
        status: "opcionalan",
        frekvencija: "1",
        opis: "Ime majke."
      },
      {
        naziv: "Broj kartice",
        LDAP_naziv: "sumEduPersonCardNum",
        status: "opcionalan",
        frekvencija: "n",
        opis: "Broj važeće kartice."
      },
      {
        naziv: "Registarske oznake",
        LDAP_naziv: "carLicence",
        status: "opcionalan",
        frekvencija: "n",
        opis: "Registarska oznaka automobila."
      },
      {
        naziv: "Nacionalnost",
        LDAP_naziv: "sumEduPersonNationaliti",
        status: "opcionalan",
        frekvencija: "n",
        opis: "Nacionalna pripadnost korisnika."
      },
      {
        naziv: "Državljanstvo",
        LDAP_naziv: "sumEduPersonCitizienship",
        status: "obvezan",
        frekvencija: "1",
        opis: "Državljanstvo korisnika."
      },
      {
        naziv: "Država rođenja",
        LDAP_naziv: "sumEduPersonBirthCountry",
        status: "obvezan",
        frekvencija: "1",
        opis: "Država rođenja."
      },
      {
        naziv: "Općina rođenja",
        LDAP_naziv: "sumEduPersonBirthMunicipality",
        status: "obvezan",
        frekvencija: "1",
        opis: "Općina rođenja."
      },
      {
        naziv: "Mjesto rođenja",
        LDAP_naziv: "sumEduPersonPlacesOfBirth",
        status: "obvezan",
        frekvencija: "1",
        opis: "Mjesto rođenja."
      },
      {
        naziv: "Srednja škola",
        LDAP_naziv: "sumEduPerosnSecondarySchool",
        status: "obvezan",
        frekvencija: "1",
        opis: "Naziv prethodno završene srednje škole."
      }
    ]
  })
};
</script>

<style>
.v-data-table {
  border-radius: 8px;
  box-shadow: 0px 20px 60px rgba(9, 14, 24, 0.1) !important;
}

th {
  color: #090e18 !important;
  font-size: 14px !important;
  font-weight: bold;
}

td {
  height: 60px !important;
}

.v-menu__content {
  box-shadow: 0px 20px 60px rgba(9, 14, 24, 0.15) !important;
  border-radius: 8px;
}
@media only screen and (max-width: 600px) {
  .description .v-list-item {
    flex-direction: column;
    min-height: unset;
  }
  .v-menu__content {
    left: unset !important;
    margin: 0 12px;
  }
}
</style>
